import Route from '@ember/routing/route';
import { service } from '@ember/service';
import ContactModel from 'donor-elf-web/models/contact';
import ContactsCache from 'donor-elf-web/services/contacts-cache';
import { TrackedArray } from 'tracked-built-ins';

export interface GroupIndexRouteModel {
  group: string; // group name
  contacts: ContactModel[];
}

export default class GroupIndexRoute extends Route {
  @service declare contactsCache: ContactsCache;

  model(): GroupIndexRouteModel {
    const groupModel = this.modelFor(
      'funds.fund.groups.group',
    ) as GroupIndexRouteModel;
    const groupContacts =
      this.contactsCache.groupContacts[groupModel.group]?.contacts;

    return {
      ...groupModel,
      contacts: new TrackedArray(groupContacts),
    };
  }
}
